import PropTypes from "prop-types";
import { useRef, useState } from "react";

import { FloatBox } from "../../../../../core";
import { Filter } from "../../../../../core/icons";

import EnrollmentStatusFilter from "../../Common/EnrollmentStatusFilter";

import { useStudents } from "../../../../../redux/Students/hooks";

function EnrollmentHeader({ onFilter }) {
  const studentsState = useStudents();

  const containerRef = useRef(null);
  const [show, setShow] = useState(false);

  const outSideClick = (state) => setShow(state);

  return (
    <div
      role="button"
      ref={containerRef}
      onClick={() => setShow(!show)}
      id="students-enrollment-options-filter-button"
      className={`
        flex
        flex-row
        items-center
        justify-center
        ${
          studentsState.isLoading
            ? "pointer-events-none"
            : "pointer-events-auto"
        }
      `}
    >
      <div className="relative place-self-center">
        &nbsp;
        <FloatBox
          open={show}
          width={250}
          containerRef={containerRef}
          handleOnClickOutside={outSideClick}
          className="
            p-4
            mt-2
            -ml-12
            bg-white
            border-black
          "
        >
          <EnrollmentStatusFilter
            onSelect={onFilter}
            id="students-affordability-options-filter-item-button"
          />
        </FloatBox>
      </div>
      <div className="mr-2 place-self-center">
        <Filter size={15} />
      </div>
      <span className="text-sm">Progress</span>
    </div>
  );
}

EnrollmentHeader.protoTypes = {
  onFilter: PropTypes.func,
};

EnrollmentHeader.defaultProp = {
  onFilter: () => {},
};

export { EnrollmentHeader };
